import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tooltip } from '@bst/react-ui';

/**
 * Application Logo for Nav Bar
 */
export const AppLogo = () => {
  const { t } = useTranslation();

  return (
    <div className="l-header__left u-hide-sm-down">
      <Tooltip content={t("title")}>
        <Link to="/">
          <div className="app-home is-active">
            <span className="app-home__logo">
              <i className="icon icon-bst_solid"></i>
            </span>
            <span className="app-home__app-name" data-testid="app title">
              {t("title")}
            </span>
          </div>
        </Link>
      </Tooltip>
    </div>
  );
};
